<div id="course-card">
  <mat-card appearance="outlined" class="p-0">
    <mat-card-content>
      <mat-card-title class="header" (click)="navigate()">
        @if (course.shareLevel === 'web' && course.shareToken) {
          <mat-icon [matTooltip]="'Global.SharedPublicly' | translate">public</mat-icon>
        } @else {
          <mat-icon>menu_book</mat-icon>
        }
        <strong>{{ course.actualName || course.name }}</strong>
      </mat-card-title>
      <p class="text" (click)="navigate()">
        {{ course.actualDescription || course.description }}
      </p>

      <div class="footer">
        <div class="footer-end d-flex">
          <ng-container *ngTemplateOutlet="cardMenu"></ng-container>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<ng-template #cardMenu>
  <mat-menu #appMenu="matMenu" yPosition="above" xPosition="before">
    @if (course.isAdmin && createMode) {
      <button mat-menu-item (click)="openAddDialog('set-title', course._id)">
        {{ 'Global.EditName' | translate }}
      </button>
    }
    @if (course.isAdmin && createMode) {
      <button mat-menu-item (click)="openAddDialog('set-description', course._id)">
        {{ 'Global.EditDescription' | translate }}
      </button>
    }
    <!-- <button mat-menu-item *ngIf="course.isAdmin && createMode" (click)="addCourseToPath(course._id)">
    {{ 'Path.AddToPath' | translate }}
  </button> -->
    @if (course.isAdmin && createMode) {
      <button mat-menu-item (click)="openShareMenu(course._id)">
        {{ 'Global.Share' | translate }}
      </button>
    }
    @if (!isArchived) {
      <button mat-menu-item (click)="archiveCourse(course._id)">
        {{ 'Global.Archive' | translate }}
      </button>
    }
    @if (isArchived) {
      <button mat-menu-item (click)="unarchiveCourse(course._id)">
        {{ 'Global.Unarchive' | translate }}
      </button>
    }
    @if (course.isAdmin && createMode) {
      <button mat-menu-item (click)="deleteCourse(course._id, course.actualName || course.name)">
        {{ 'Global.Delete' | translate }}
      </button>
    }
  </mat-menu>
  <button mat-icon-button [matMenuTriggerFor]="appMenu">
    <mat-icon>more_horiz</mat-icon>
  </button>
</ng-template>
